import { useEffect, useState } from 'react';
import SiteLink from 'components/shared/sitelink/sitelink';
import classNames from 'classnames';
import useScrollDown from 'hooks/utils/useScrolldown';
import FaqMobileNav from 'components/pages/faq/faqMobileNav';
import { getChooseTopicLabel, getCloseLabel } from 'components/pages/faq/breadcrumbs';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useRouter } from 'next/router';
import { useGlobalModules, useUI } from 'contexts';
import styles from './professionalsHeader.module.scss';

const ProfessionalsHeader = ({ data, locale }) => {
  const {
    button,
    navbar: { submenus },
    anchorId,
  } = data;

  const globalModules = useGlobalModules();
  const { displayMenuDrawer } = useUI();

  const [selectedLink, setSelectedLink] = useState(null);
  const { positionTop } = useScrollDown();
  const router = useRouter();
  const mobileItems = submenus.map(submenu => ({
    id: submenu.link.title,
    label: submenu.link.title,
    href: submenu.link.slug || '',
    external: submenu.link.externalLink,
    reloaded: submenu.link.pageReload,
    isActive: submenu === selectedLink,
  }));

  // Find the link that is the same as the current [slug]
  useEffect(() => {
    setSelectedLink(submenus.find(submenu => submenu.link.slug === router.query.slug));
  }, [submenus, router.query.slug]);

  return (
    <div
      id={anchorId}
      className={classNames(styles.professionalsHeader, {
        [styles.scrolled]: !positionTop,
        [styles.menuDrawerOpen]: displayMenuDrawer,
      })}
    >
      <nav className={styles.nav}>
        <ul className={styles.professionalsLinks}>
          {submenus.slice(0, 5).map(submenu => (
            <li
              className={classNames(styles.navItem, {
                [styles.selected]: selectedLink === submenu,
              })}
              key={submenu.link.title}
            >
              <SiteLink
                locale={locale}
                reloaded={submenu.link.pageReload}
                external={submenu.link.externalLink}
                href={addLocaleToHref(submenu.link.slug, locale, router)}
              >
                <h2>{submenu.link.title}</h2>
              </SiteLink>
            </li>
          ))}
        </ul>
        <FaqMobileNav
          id="professionals-mobile-drawer"
          items={mobileItems}
          locale={locale}
          chooseTopicLabel={getChooseTopicLabel(globalModules, locale)}
          closeLabel={getCloseLabel(globalModules, locale)}
        />
      </nav>
      <div
        className={classNames(styles.navbarButton, {
          [styles.scrolledNavbarButton]: !positionTop,
        })}
      >
        <SiteLink locale={locale} href={addLocaleToHref(button?.link?.slug, locale, router)}>
          {button?.title}
        </SiteLink>
      </div>
    </div>
  );
};

export default ProfessionalsHeader;
